module.exports = __webpack_public_path__ + "static/firewall-ui-f0cecc218be66524230c6882a54f8abb.webp";